import { Capacitor } from '@capacitor/core';

/**
 * `true` when running inside a Capacitor native shell (iOS/Android).
 * `false` in the PWA / browser. Wrap any plugin call with this so the web
 * build stays functional without native APIs.
 */
export function isNative(): boolean {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}

export function platform(): 'ios' | 'android' | 'web' {
  try {
    const p = Capacitor.getPlatform();
    if (p === 'ios' || p === 'android') return p;
    return 'web';
  } catch {
    return 'web';
  }
}
